

import TiwiMixin from '../mixins/TiwiMixin'
import SaveButton from './SaveButton'
import CommentButton from './CommentButton'
import ShareButton from './ShareButton'
import LikeButton from './LikeButton'

export default {
  mixins: [ TiwiMixin ],
  components: { LikeButton, SaveButton, CommentButton, ShareButton },
  props: {
    post: {
      required: true,
      type: Object,
    },
    className: {
      required: false,
      type: String,
      default: '',
    },
    isCover: {
      type: Boolean,
      required: false,
      default: false
    },
  },

}
